import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';

import { plainToClass } from 'class-transformer';

import { ConstantsService } from '../../services/constants-service';
import { ObservableRequestService } from '../../services/observable-request.service';

import { Process } from 'app/shared/models/process.model';
import { TaskDefinition } from 'app/shared/models/task-definition.model';

/**
 * Service for processes and task definitions related calls.
 */
@Injectable()
export class ProcessService {
    constructor(
        private requestService: ObservableRequestService,
        private domSanitizer: DomSanitizer) { }

    // Get all processes for the listing
    getProcesses(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.LOAD_PROCESS_LIST)
        .map(response => {
            return plainToClass(Process, response.arrResult as Object[]);
        });
    };

    // Get all tasks of selected process.
    getProcessTasks(processId: string): Observable<any> {
        const processTaskList = ConstantsService.LOAD_PROCESS_TASK_LIST + '/' + processId;
        return this.requestService.getRequest(processTaskList)
        .map(response => {
            return plainToClass(TaskDefinition, response.arrResult as Object[]);
        });
    };

    // Update task guide text through editor.
    updateTaskGuideText(taskGuideTextData: TaskDefinition): Observable<any> {
        return this.requestService.putRequest(ConstantsService.TASK_GUIDE_UPDATE_URL,
        JSON.stringify(taskGuideTextData),
        this.requestService.getJSONContentType());
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/processes/process.service.ts